import { render, staticRenderFns } from "./TextParsing.vue?vue&type=template&id=38740477&"
import script from "./TextParsing.vue?vue&type=script&lang=js&"
export * from "./TextParsing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports